'use strict';

var integrations = require('integrations/productDetail');
var productExtensions = [];

var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();

var productDetailsBase = {
    detail: require('./product/detail')
};

if (toggleObject.turntoCartridgeEnabled) {
    let turntoDetail = {
        detail: require('./integrations/turnto/product/detail')
    };
    productDetailsBase.detail = $.extend({}, productDetailsBase.detail, turntoDetail.detail);
}

productExtensions.push(productDetailsBase);

productExtensions.forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        if (typeof library[item] === 'object') {
            integrations.baseFiles[item] = $.extend({}, integrations.baseFiles[item], library[item]);
        } else {
            integrations.baseFiles[item] = library[item];
        }
    });
});

module.exports = integrations;

